import React from "react";

export const IntelligenceLayerSection = () => {
  const steps = [
    {
      num: 1,
      title: "Real-World Data",
      desc: "Robot operations, IoT sensors and environments",
      hasGlow: false,
      icon: (
        // Database Cylinder Icon with 3 stacked layers
        <svg
          className="w-7 h-7 sm:w-8 sm:h-8"
          viewBox="0 0 24 24"
          fill="none"
          stroke="rgba(117, 209, 249, 1)"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <ellipse cx="12" cy="5.5" rx="7.5" ry="2.6" />
          <path d="M4.5 5.5v13c0 1.5 3.36 2.6 7.5 2.6s7.5-1.1 7.5-2.6v-13" />
          <path d="M4.5 10c0 1.5 3.36 2.6 7.5 2.6s7.5-1.1 7.5-2.6" />
          <path d="M4.5 14.5c0 1.5 3.36 2.6 7.5 2.6s7.5-1.1 7.5-2.6" />
        </svg>
      ),
    },
    {
      num: 2,
      title: "Process",
      desc: "Clean, sync and structure data at scale",
      hasGlow: false,
      icon: (
        // Server Rack with 3 drawers and indicators
        <svg
          className="w-7 h-7 sm:w-8 sm:h-8"
          viewBox="0 0 24 24"
          fill="none"
          stroke="rgba(117, 209, 249, 1)"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="4" y="3" width="16" height="18" rx="2" />
          <line x1="4" y1="9" x2="20" y2="9" />
          <line x1="4" y1="15" x2="20" y2="15" />
          <line x1="7" y1="6" x2="9" y2="6" strokeWidth="2.2" strokeLinecap="round" />
          <line x1="15" y1="6" x2="17" y2="6" strokeWidth="2.2" strokeLinecap="round" />
          <line x1="7" y1="12" x2="9" y2="12" strokeWidth="2.2" strokeLinecap="round" />
          <line x1="15" y1="12" x2="17" y2="12" strokeWidth="2.2" strokeLinecap="round" />
          <line x1="7" y1="18" x2="9" y2="18" strokeWidth="2.2" strokeLinecap="round" />
          <line x1="15" y1="18" x2="17" y2="18" strokeWidth="2.2" strokeLinecap="round" />
        </svg>
      ),
    },
    {
      num: 3,
      title: "Train",
      desc: "Train models for perception, navigation and task execution",
      hasGlow: true,
      icon: (
        // Neural Brain Circuit with lobe silhouettes & circuit nodes
        <svg
          className="w-7 h-7 sm:w-8 sm:h-8"
          viewBox="0 0 24 24"
          fill="none"
          stroke="rgba(117, 209, 249, 1)"
          strokeWidth="2.1"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {/* Left Hemisphere Outline */}
          <path d="M12 4.5a3.2 3.2 0 0 0-3.2-1.5c-1.8.2-3.1 1.6-3.1 3.4 0 .4.1.8.2 1.2A3.2 3.2 0 0 0 4 11.2c0 1.2.6 2.3 1.6 2.8a3.4 3.4 0 0 0 .8 5.2c1.2.9 2.8 1 4.1.3.5-.3 1-.7 1.5-1.5" />
          {/* Right Hemisphere Outline */}
          <path d="M12 4.5a3.2 3.2 0 0 1 3.2-1.5c1.8.2 3.1 1.6 3.1 3.4 0 .4-.1.8-.2 1.2a3.2 3.2 0 0 1 1.9 3.6c0 1.2-.6 2.3-1.6 2.8a3.4 3.4 0 0 1-.8 5.2c-1.2.9-2.8 1-4.1.3-.5-.3-1-.7-1.5-1.5" />
          {/* Center Dividing Stem */}
          <line x1="12" y1="4.5" x2="12" y2="19.5" />
          {/* Circuit Tracks & Nodes */}
          <line x1="12" y1="9" x2="9.5" y2="9" />
          <circle cx="8" cy="9" r="1.2" fill="rgba(117, 209, 249, 1)" stroke="none" />
          <line x1="12" y1="15" x2="9.5" y2="15" />
          <circle cx="8" cy="15" r="1.2" fill="rgba(117, 209, 249, 1)" stroke="none" />
          <line x1="12" y1="12" x2="14.5" y2="12" />
          <circle cx="16" cy="12" r="1.2" fill="rgba(117, 209, 249, 1)" stroke="none" />
        </svg>
      ),
    },
    {
      num: 4,
      title: "Validate",
      desc: "Test in simulation and real environments",
      hasGlow: false,
      icon: (
        // Isometric 3D Cube Box
        <svg
          className="w-7 h-7 sm:w-8 sm:h-8"
          viewBox="0 0 24 24"
          fill="none"
          stroke="rgba(117, 209, 249, 1)"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 2.5 20 7v10l-8 4.5L4 17V7l8-4.5Z" />
          <path d="M12 11.8 20 7" />
          <path d="m12 11.8-8-4.8" />
          <path d="M12 11.8v9.7" />
        </svg>
      ),
    },
    {
      num: 5,
      title: "Deploy",
      desc: "Robots that work reliably in real operations",
      hasGlow: false,
      icon: (
        // Rocket Ship Tilted 45° with Porthole & Flame
        <svg
          className="w-7 h-7 sm:w-8 sm:h-8"
          viewBox="0 0 24 24"
          fill="none"
          stroke="rgba(117, 209, 249, 1)"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
          <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
          <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
          <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
          <circle cx="15.5" cy="8.5" r="1.5" fill="rgba(117, 209, 249, 1)" stroke="none" />
        </svg>
      ),
    },
  ];

  return (
    <section
      className="relative w-full overflow-hidden min-h-[580px] sm:min-h-[613px] flex flex-col justify-between py-16 sm:py-20 lg:py-24"
      style={{
        backgroundColor: "rgba(0, 12, 23, 1)",
      }}
    >
      {/* Background Looping Video with 50% opacity */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-50"
      >
        <source src="/videos/intelligence-layer-bg.mp4" type="video/mp4" />
      </video>

      {/* Figma Specified Linear Gradient Overlay */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(0, 25, 41, 0) 0%, rgba(0, 25, 41, 0.4) 60%, rgba(0, 25, 41, 1) 100%)",
        }}
      />

      <div className="relative z-10 mx-auto w-full max-w-[1440px] px-6 sm:px-12 lg:px-16 flex flex-col justify-between h-full">
        {/* Top Header Row */}
        <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          {/* Left Column: Eyebrow + Main Headline */}
          <div className="flex flex-col items-start gap-2.5 max-w-[560px]">
            <p className="text-[11px] sm:text-[11.5px] font-bold uppercase tracking-[2.8px] text-[#7E95B3]">
              THE INTELLIGENCE LAYER
            </p>
            <h2
              className="text-[28px] sm:text-[36px] lg:text-[42px] xl:text-[46px] font-bold leading-[1.15] tracking-[-1.2px] text-white"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              <span className="block whitespace-nowrap">From real-world data</span>
              <span className="block whitespace-nowrap mt-0.5 sm:mt-1">
                to intelligent robots.
              </span>
            </h2>
          </div>

          {/* Right Column: Divider + Paragraph */}
          <div className="lg:border-l lg:border-white/20 lg:pl-8 xl:pl-10 max-w-[480px]">
            <p className="text-[14px] sm:text-[15px] leading-[23px] text-[#A0B4CC]">
              We combine real-world data, IoT, vision and robotics to build practical AI models that power reliable autonomy in real environments.
            </p>
          </div>
        </div>

        {/* Bottom: 5 Process Steps Flow with exact icons & arrows positioned exactly as in screenshot */}
        <div className="mt-14 sm:mt-16 lg:mt-20">
          <div className="overflow-x-auto pb-4 pt-2 -mx-4 px-4 sm:mx-0 sm:px-0">
            <div className="min-w-[860px] grid grid-cols-5 gap-3 lg:gap-6 relative">
              {steps.map((step, idx) => (
                <div
                  key={step.num}
                  className="relative flex flex-col items-center group text-left"
                >
                  {/* Top Circle Container with Connecting Arrow Centered in the Gap */}
                  <div className="relative w-full flex items-center justify-center">
                    {/* Circle Icon Container with exact rgba(2, 57, 129, 0.8) */}
                    <div
                      className={`flex h-[64px] w-[64px] sm:h-[70px] sm:w-[70px] items-center justify-center rounded-full transition-all duration-300 group-hover:scale-105 shrink-0 ${
                        step.hasGlow
                          ? "border-[1.5px] border-[#00C2FF]/75 shadow-[0_0_18px_rgba(0,194,255,0.4)]"
                          : "border border-[#0D4B8E]/50"
                      }`}
                      style={{ backgroundColor: "rgba(2, 57, 129, 0.8)" }}
                    >
                      {step.icon}
                    </div>

                    {/* Connecting Arrow between this step and next step (Vertically and Horizontally Centered between circles) */}
                    {idx < steps.length - 1 && (
                      <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 z-20 flex items-center justify-center pointer-events-none">
                        <svg
                          className="w-5 h-5 sm:w-6 sm:h-6 transition-transform duration-300 group-hover:translate-x-0.5"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="rgba(120, 213, 255, 1)"
                          strokeWidth="2.4"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="4" y1="12" x2="20" y2="12" />
                          <polyline points="13 5 20 12 13 19" />
                        </svg>
                      </div>
                    )}
                  </div>

                  {/* Text Container aligned under the circle */}
                  <div className="w-full max-w-[180px] lg:max-w-[200px] mt-5 flex flex-col items-start">
                    {/* Number Badge + Title Row */}
                    <div className="flex items-center gap-2">
                      <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#007AFF] text-[11.5px] font-bold text-white shadow-sm">
                        {step.num}
                      </span>
                      <h3 className="text-[14.5px] sm:text-[15.5px] lg:text-[16px] font-bold text-white whitespace-nowrap">
                        {step.title}
                      </h3>
                    </div>

                    {/* Description Paragraph */}
                    <p className="mt-2 text-[12px] sm:text-[12.5px] leading-[17.5px] text-[#8E9CAE]">
                      {step.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntelligenceLayerSection;
